<div class="row align-items-center justify-content-between">
    <div class="col-auto">
        <h3 class="heading" *ngIf="registers">{{ "HOME.COURSES-AND-EVENTS" | translate }}</h3>
    </div>
    <div class="col-auto align-self-center ml-auto">
        <button nbButton status="primary" size="small" outline [routerLink]="['/events']">
            {{ "GENERAL.SEE-ALL" | translate }}
        </button>
    </div>
</div>
<ngx-glide
    *ngIf="registers && registers.length"
    [showBullets]="false"
    [arrowLeftTemplate]="arrowLeft"
    [arrowRightTemplate]="arrowRight"
    [breakpoints]="breakpoints"
    #ngxGlide
>
    <app-card-featured
        [routerLink]="['/events', event.id_evento]"
        [title]="event.descricao"
        accent="primary"
        [date]="event.dt_inicio + ' ' + translate.instant('GENERAL.UNTIL') + ' ' + event.dt_final"
        [location]="event.cidade + ' / ' + event.uf"
        filled="true"
        *ngFor="let event of registers"
    >
        <div tag class="d-flex align-items-center mb-2">
            <img
                width="32"
                height="32"
                class="border-radius-100 mr-2"
                [src]="event.url_avatar"
                [alt]="event.nome_abreviado_dono_evento"
            />
            <span>{{ "GENERAL.CREATED-BY" | translate }} {{ event.nome_abreviado_dono_evento }}</span>
        </div>
    </app-card-featured>
</ngx-glide>

<ng-template #arrowLeft>
    <button nbButton size="small"><nb-icon icon="arrow-ios-back-outline"></nb-icon></button>
</ng-template>
<ng-template #arrowRight>
    <button nbButton size="small"><nb-icon icon="arrow-ios-forward-outline"></nb-icon></button>
</ng-template>
